export default "__VITE_ASSET__DBgfitoP__"